<template>
  <div class="grid-view">
    <div class="main-content">
      <search-bar config-module="3300002" :filter="searchConditions" :show-form-item="true" :ocr-tab="OCR_TAB_FINISHED.code" @toQuery="toQuery" @change="searchChange" />
      <div class="section grid-wrapper">
        <intelligent-booking-table
          :row-data="rowData"
          tab-type="tabFinished"
          config-module="3300022"
          @showDetails="(e)=>this.$emit('showDetails',e)"
          @refresh="fetchData"
        />
      </div>
      <div class="pagination-wrapper">
        <cargo-pagination
          config-module="intelligent-tab-finished"
          :total="searchConditions.total"
          :page.sync="searchConditions.pageNum"
          :limit.sync="searchConditions.pageSize"
          @pagination="queryPageHandler"
        />
      </div>
    </div>
  </div>
</template>

<script>
import IntelligentBookingTable from '@/views/cargo/v0/ToolAssistant/ocr/components/IntelligentBookingTable'
import { getLoading } from '@/utils/utilBaseElement'
import { advancedQueryIntelligentDocument } from '@/api/seaExport/intelligentBooking'
import SearchBar from '@/views/cargo/v0/ToolAssistant/ocr/components/SearchBar'
import {
  JOB_BOOKING_STATE_BOOKING_FAIL,
  JOB_BOOKING_STATE_BOOKING_SEND_FAIL,
  JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL,
  JOB_BOOKING_STATE_VALID_FAIL,
  OCR_TAB_FINISHED,
  OCR_TAB_IDENTIFY
} from '@/class/cargo/model/parameters/SystemConstants'
import AdvancedSearchOption from '@/class/cargo/model/parameters/AdvancedSearchOption'
import AdvancedSearchConsts from '@/class/cargo/model/parameters/OperatorConstants'
export default {
  name: 'TabFinished',
  components: { SearchBar, IntelligentBookingTable },
  data() {
    return {
      rowData: [],
      searchConditions: {
        total: 0,
        iType: -1,
        pageNum: 1,
        pageSize: 50,
        status: [3],
        days: 7
      },
      OCR_TAB_FINISHED, OCR_TAB_IDENTIFY
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.fetchData()
    },
    fetchData(params = this.searchConditions) {
      console.log('fetchFinished')
      this.loading = getLoading()
      if (params && params.conditions) {
        const data = params.conditions
        // 订舱状态
        if (AdvancedSearchOption.hasField('intelligentDocumentItem.STATUS', data)) {
          const state = AdvancedSearchOption.getOption('intelligentDocumentItem.STATUS', data)
          if (state && state.value && state.value.includes(JOB_BOOKING_STATE_BOOKING_FAIL.code)) {
            state.value = [...state.value, JOB_BOOKING_STATE_BOOKING_SEND_FAIL.code, JOB_BOOKING_STATE_VALID_FAIL.code, JOB_BOOKING_STATE_TEMPLATE_MATCH_FAIL.code]
            AdvancedSearchOption.removeOption('intelligentDocumentItem.STATUS', data)
            data.push(new AdvancedSearchOption(null, 'job.BOOKING_STATE', state.value, AdvancedSearchConsts.OPERATOR_IN.code).formatObj2Json())
          }
        }
      }
      advancedQueryIntelligentDocument(params).then(res => {
        const { data } = res
        this.rowData = data.list
        this.searchConditions.total = Number(data.total)
        this.searchConditions.pageNum = data.pageNum
        this.searchConditions.pageSize = data.pageSize
      }).finally(() => {
        this.loading.close()
      })
    },
    queryPageHandler() {
      this.fetchData(this.searchConditions)
    },
    searchChange(e) {
      console.log(e)
      const params = this.searchConditions
      params.pageNum = 1
      switch (e.type) {
        case 'input':
          params.fileName = e.value
          break
        case 'select':
          params.iType = e.value
          break
        default:
          if (e.value) {
            params.days = e.value
          }
          params.fileName = ''
          break
      }
      this.fetchData(params)
    },
    toQuery() {
      this.fetchData()
    }

  }
}
</script>

<style scoped>

</style>
